import { Pipe, PipeTransform } from '@angular/core';
import { validateNumber } from '@shared-libs/helpers';

@Pipe({ name: 'currency' })
export class CurrencyPipe implements PipeTransform {
	transform(_value: number, currency: string = '€'): string {
		const { valid, value } = validateNumber(_value);

		if (!valid) return value as any as string;

		if (value % 1 !== 0) {
			return `${currency}${value
				.toFixed(2)
				.replace('.', ',')
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
		} else return `${currency}${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
	}
}
